import {BannerParams} from './config/BannerParams';
import {BannerTransport} from './transport/BannerTransport';
import type {IBannerTransport} from './transport/IBannerTransport';
import {BannerConstant} from './util/BannerConstant';
import type {ValueProvider} from './util/ValueProvider';

import {BannerRequest, IResponseListener} from './BannerRequest';

export class BannerModel {
    slot: ValueProvider<string>;
    params: BannerParams;
    loader: IBannerTransport;

    constructor(slot: ValueProvider<string>, params: BannerParams, loader: IBannerTransport) {
        this.loader = loader;
        this.slot = slot;
        this.params = params;
    }

    request(container: HTMLElement, ready: IResponseListener): BannerRequest {
        const request = new BannerRequest(container, ready, this.slot, this.params.getBannerCfg().place);
        this.process(request);
        return request;
    }

    click(clickUrl: string) {

        let params = {
            r: Date.now() + ""
        };

        const {bannerTargeting} = this.params.getBannerCfg();

        const t = bannerTargeting[BannerConstant.TARGETING_PARAMETER];
        if (t) {
            BannerTransport.appendParam(params, BannerConstant.TARGETING_PARAMETER, t);
        }

        this.loader.sendClick(clickUrl, params);
    }

    process(request: BannerRequest) {
        if (this.slot.getValue() !== null) {
            this.sendReq(request);
        } else {
            request.handleResponse(null);
        }
    }

    sendReq(request: BannerRequest) {
        this.loader.sendRequest(this.slot.getValue(), this.params.asJSON(), request);
    }
}
